module.exports = __webpack_public_path__ + "img/Icon=Git.1a843fe9.svg";